'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import logoGrayPrimary from '../../public/images/hive-logo-gray.png';
import logoWhitePrimary from '../../public/images/hive-logo-white.png';
import { useAppContext } from '@/app/_lib/_context';
export default function SiteBranding() {
  const $ = _c(9);
  const pathname = usePathname();
  const {
    closeMobileMenu
  } = useAppContext();
  if (pathname === "/") {
    let t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="hidden group-[.collapsed]/header:block lg:!hidden"><FontAwesomeIcon icon={faHiveIconSmallLight} aria-hidden="true" className="text-primary text-4xl" /></div>;
      t1 = <Image priority={true} className="w-[100px] h-[50px] block md:hidden group-[.opaque]/header:!hidden group-[.collapsed]/header:!hidden" src={logoWhitePrimary} quality={90} sizes="(max-width: 1023px) 88px, 90px" alt="hive - Modern Design for the Home" />;
      t2 = <Image priority={true} className="w-[100px] h-[50px] hidden group-[.opaque]/header:block md:block group-[.collapsed]/header:!hidden lg:group-[.collapsed]/header:!block" src={logoGrayPrimary} quality={90} sizes="(max-width: 1023px) 88px, 90px" alt="hive - Modern Design for the Home" />;
      $[0] = t0;
      $[1] = t1;
      $[2] = t2;
    } else {
      t0 = $[0];
      t1 = $[1];
      t2 = $[2];
    }
    let t3;
    if ($[3] !== closeMobileMenu) {
      t3 = <Link aria-label="hive - home" className="shrink-0 z-10 relative block lg:mb-4" href="/" onClick={closeMobileMenu}>{t0}{t1}{t2}</Link>;
      $[3] = closeMobileMenu;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="hidden group-[.collapsed]/header:block lg:!hidden"><FontAwesomeIcon icon={faHiveIconSmallLight} aria-hidden="true" className="text-primary text-4xl" /></div>;
    t1 = <Image priority={true} className="w-[100px] h-[50px] block group-[.collapsed]/header:!hidden lg:group-[.collapsed]/header:!block" src={logoGrayPrimary} quality={90} sizes="(max-width: 1023px) 88px, 90px" alt="hive - Modern Design for the Home" />;
    $[5] = t0;
    $[6] = t1;
  } else {
    t0 = $[5];
    t1 = $[6];
  }
  let t2;
  if ($[7] !== closeMobileMenu) {
    t2 = <Link aria-label="hive - home" className="shrink-0 z-10 block lg:mb-4" href="/" onClick={closeMobileMenu}>{t0}{t1}</Link>;
    $[7] = closeMobileMenu;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}